module.exports = __webpack_public_path__ + "img/job-professional.b876bfcb.svg";